import { Map, List } from 'immutable';

import { FETCH_INVOICES } from './types';


const initialState = Map({
  elements: List(),
  isLoading: true,
});


export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_INVOICES.REQUEST:
      return state.set('isLoading', true);
    case FETCH_INVOICES.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('elements', List(payload))
          .set('isLoading', false);
      });
    case FETCH_INVOICES.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('isLoading', false)
          .set('elements', initialState.get('elements'));
      });
    default:
      return state;
  }
};
